const invitedUsersTableHeaders = [
  'Status', 
  'Email', 
  'Resend Invite', 
  'Remove Access'
];

export { invitedUsersTableHeaders };
